import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import React from "react"

type DraggableRowProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement> & {
    "data-row-key": string
}

export const DraggableRow = (props: DraggableRowProps) => {
    const { attributes, listeners, setNodeRef, isDragging, transform, transition } = useSortable({
        id: props["data-row-key"],
    })
    const { children, ...restProps } = props
    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Transform.toString(
            transform && {
                ...transform,
                scaleY: 1,
            },
        ),
        transition,
        cursor: "move",
    }
    const className = `${isDragging && props["data-row-key"] ? "isDragging " : ""}${props.className}`
    return (
        <tr ref={setNodeRef} {...attributes} {...restProps} style={style} {...listeners} className={className}>
            {children instanceof Array
                ? children.map((child) => {
                      const { children, key, ...restProps } = child
                      return key === "sort" ? (
                          <td {...listeners} {...restProps}>
                              {child}
                          </td>
                      ) : (
                          <td {...restProps}>{child}</td>
                      )
                  })
                : children}
        </tr>
    )
}
